module.exports = __webpack_public_path__ + "images/partner6.9d6cef78.svg";